import { connect } from 'react-redux';

import { createAction as createReduxAction } from 'redux-actions';

const createAction = namespace => actionID => {
  const ACTION_CONST = `${namespace}/${actionID}`;
  const actionCreator = createReduxAction(ACTION_CONST);
  actionCreator.type = ACTION_CONST;
  return actionCreator;
};

const STATE_PROP = 'STATE_PROP';
const ACTION_PROP = 'ACTION_PROP';

const stateProp = mapStateToProp => {
  mapStateToProp.type = STATE_PROP;
  return mapStateToProp;
};

const actionProp = mapActionToProp => {
  mapActionToProp.type = ACTION_PROP;
  return mapActionToProp;
};

const combineMaps = (propsType, propsMaps) => stateOrDispatch => (
  propsMaps
  .filter(map => map.type === propsType)
  .reduce(
    (props, map) => Object.assign(props, map(stateOrDispatch)),
    {}
  )
);

const connectProps = (...propsMaps) => connect(
  combineMaps(STATE_PROP, propsMaps),
  combineMaps(ACTION_PROP, propsMaps)
);



export {
  stateProp,
  actionProp,
  connectProps,
  createAction,
};



// WEBPACK FOOTER //
// ./src/store/utils.js